import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Icon, IconButton, ListItemIcon, Menu, MenuItem, } from '@material-ui/core';
import { useState, } from 'react';
import { isBaseCompAction, isBaseCompSubAction, } from '../../componentInterfaces';
import { useModePanelStyle, } from '../../style';
import { useDropdown, } from '../../utils';
import { FontIcon, } from './FontIcon';
/**
 * This is a Generic Header component that can be used for most of the InfoComponent
 */
export const CompCustomActionsMenu = (props) => {
    const panelClasses = useModePanelStyle();
    const [customActionsMenuAnchorEl, isCustomActionsMenuOpened, onCustomActionAnchorElClicked, onCustomActionMenuClosed] = useDropdown();
    const [selectedSubMenu, setSelectedSubMenu] = useState();
    const [customActionsSubMenuAnchorEl, isCustomActionsSubMenuOpened, onCustomSubActionAnchorElClicked, onCustomActionSubMenuClosed] = useDropdown();
    if (props.customActions && props.customActions.length > 0) {
        return (_jsxs(_Fragment, { children: [_jsx(IconButton, { className: panelClasses.panelHeaderCustomActionToggler, size: "small", onClick: onCustomActionAnchorElClicked, children: _jsx(Icon, { children: "more_vert" }) }), _jsx(Menu, { getContentAnchorEl: null, anchorEl: customActionsMenuAnchorEl, anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'right',
                    }, transformOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    }, keepMounted: true, open: isCustomActionsMenuOpened, onClose: onCustomActionMenuClosed, children: props.customActions.map((action) => {
                        return (_jsxs(MenuItem, { disabled: action.disabled, onClick: (event) => {
                                if (isBaseCompAction(action)) {
                                    onCustomActionMenuClosed();
                                    action.onClick();
                                }
                                else if (isBaseCompSubAction(action)) {
                                    setSelectedSubMenu(action);
                                    onCustomSubActionAnchorElClicked(event);
                                }
                            }, children: [action.icon && (_jsx(ListItemIcon, { children: _jsx(FontIcon, { iconName: action.icon }) })), action.label] }, action.label || action.icon));
                    }) }), selectedSubMenu && (_jsx(Menu, { getContentAnchorEl: null, anchorEl: customActionsSubMenuAnchorEl, anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                    }, transformOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    }, keepMounted: true, open: isCustomActionsSubMenuOpened, onClose: onCustomActionSubMenuClosed, children: selectedSubMenu.actions.map((action) => {
                        return (_jsxs(MenuItem, { disabled: action.disabled, onClick: () => {
                                onCustomActionMenuClosed();
                                onCustomActionSubMenuClosed();
                                action.onClick();
                            }, children: [action.icon && (_jsx(ListItemIcon, { children: _jsx(FontIcon, { iconName: action.icon }) })), action.label] }, action.label || action.icon));
                    }) }))] }));
    }
    return (_jsx(_Fragment, {}));
};
